import combinedGACall from '../combinedGACall';

export default (action, label) =>
	combinedGACall({
		category: 'My employees',
		action,
		...(label ? { label } : null),
	});
